/**
 * App configuration from environment variables
 */
// Vite loads `.env.local` in every mode, including production builds. Gate dev
// auth on PROD so a stale VITE_DEV_AUTH=1 can't leak X-Dev-User-Id into a prod
// bundle and trip CORS (header isn't in the server's allowlist).
// `VITE_API_BASE_URL` lives in `.env.production`, which is tracked -- the `.local` variants are
// gitignored, so a build on a machine that never had them (the server) got no value at all and
// fell back to localhost. A production bundle pointing at localhost:3000 hangs the mini app on
// "Authenticating..." with a CORS error, so the fallback is dev-only now.
export const config = {
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    (import.meta.env.PROD ? 'https://api.kentozo.xyz' : 'http://localhost:3000'),
  mockMode: import.meta.env.VITE_MOCK === '1',
  devAuth: !import.meta.env.PROD && import.meta.env.VITE_DEV_AUTH === '1',
  devUserId: import.meta.env.VITE_DEV_USER_ID
    ? parseInt(import.meta.env.VITE_DEV_USER_ID, 10)
    : undefined,
} as const;

export const isDev = import.meta.env.DEV;
export const isProd = import.meta.env.PROD;
